<template>
  <div class="max-w-7xl mx-auto py-2 md:py-6 sm:px-6 lg:px-4 grid grid-cols-2 gap-4">
    <section class="p-4 col-span-2">
      <header-block-component></header-block-component>
    </section>
    <section class="p-4 mt-6 col-span-2">
      <banner-branding-component></banner-branding-component>
    </section>
    <section class="p-4 mt-6 col-span-2">
      <description-component></description-component>
    </section>
    <help-center-component :url="this.helpCenter.kn_branding_url" class="pl-3"></help-center-component>
  </div>
</template>

<script>
import HeaderBlockComponent from "@/views/customization/home/HeaderBlockComponent";
import BannerBrandingComponent from "@/views/customization/branding/BannerBrandingComponent";
import DescriptionComponent from "@/views/customization/home/DescriptionComponent";
import HelpCenterComponent from "@/views/common/HelpCenterComponent";
import helpcenter from "@/services/helpcenter/links";

/* Personalización › Portada: tipo de encabezado, banner y descripción de la home. */
export default {
  name: "HomeComponent",
  components: {
    HeaderBlockComponent,
    BannerBrandingComponent,
    DescriptionComponent,
    HelpCenterComponent,
  },
  setup() {
    return {
      helpCenter: helpcenter,
    }
  },
}
</script>
